import React, {useEffect, useState} from 'react';
import {useFetching} from "../../hooks/useFetching";
import {API_ABOUT_ABOUT_US} from "../../utils/consts";
import parse from "html-react-parser";
import {useLocation} from "react-router-dom";
import ApiAboutAboutUs from "../../services/About/AboutUs";
import {observer} from "mobx-react-lite";
import Loading from "../Loading";

const AboutUs = () => {
    const location = useLocation();

    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Про нас', content1: '<p>Champion™ знаходиться на ринку азартних ігор з 2008 року і продовжує розширювати лінійку продуктів та послуг, щоб задовольняти потреби своїх клієнтів та перевершувати їхні очікування. На сьогодні Champion™ - це група компаній, що розташовані в країнах Європейського Союзу, СНД і Великій Британії.</p>\n' + '<p><br>Наша компанія адаптує свою продукцію до потреб кожної країни і, відповідно, до кожного замовника. Завдяки моніторингу регіонального законодавства ми маємо конкурентну перевагу в галузі грального бізнесу.</p>', number_1: '10', number_1_label: 'РОКІВ ДОСВІДУ', number_2: '30', number_2_label: 'ОНЛАЙН-ПРОЕКТІВ', content2: '<p>За понад 10 років досвіду в сегменті азартного бізнесу, Champion™ реалізувала декілька успішних державних проектів електронних лотерей та запустила більше 30 онлайн-проектів під ключ.</p>'});

    const [FunctionApiAboutAboutUs] = useFetching(async () => {
        try {
            const response = await ApiAboutAboutUs.getApiAboutAboutUs(API_ABOUT_ABOUT_US);
            setData(response.data);
        } catch {
            console.error('FunctionApiAboutAboutUs')
        }
    });

    useEffect(() => {
        FunctionApiAboutAboutUs();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {data ? <div className="block_about up_catalog">
                <div className="title_block">
                    {data?.name && <h1>{data?.name}</h1>}
                    {data?.content_1 && parse(data?.content_1)}
                </div>
                {data?.number_1 && data?.number_2 ? <div className="title_number">
                    <div className="title_number_block">
                        {data?.number_1 && <span className="num">{data.number_1}</span>}
                        {data?.number_1_label && <span className="num_desc">{data.number_1_label}</span>}
                    </div>
                    <div className="title_number_block">
                        {data?.number_2 && <span className="num">{data.number_2}</span>}
                        {data?.number_2_label && <span className="num_desc">{data.number_2_label}</span>}
                    </div>
                </div> : null}
                {data?.content_2 ? <div className="title_block">
                    {parse(data.content_2)}
                </div> : null}
            </div> : <Loading />}
        </>
    );
};

export default observer(AboutUs);